import React from "react";
import "./LoadingSpiner.css";
const LoadingSpiner = () => {
  return <div className="spinner centered"></div>;
};

export default LoadingSpiner;
